export default "__VITE_ASSET__BZU$5h6Z__"